export const convertFileToDataUrl = (file, setFile) => {
    const reader = new FileReader();
    reader.onload = () => {
      const [metadata, base64Data] = reader.result.split(',');
      setFile(`data:image/png;base64,${base64Data}`);
    };
    reader.readAsDataURL(file);
  };